export default __webpack_public_path__ + "static/dress-11034d7127d5473f972fe66cc31fec80.mp4";